import React from 'react';
import { useTranslation } from 'react-i18next';
import GenericTablePage from '../components/GenericTablePage';
import { GridColDef } from '@mui/x-data-grid';
import { Chip } from '@mui/material';

const DocumentTemplatesPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const columns: GridColDef[] = [
    { field: 'name', headerName: t('documentTemplates.name'), flex: 1, minWidth: 220 },
    { field: 'description', headerName: t('documentTemplates.description'), flex: 1, minWidth: 200 },
    {
      field: 'is_default',
      headerName: t('documentTemplates.isDefault'),
      width: 130,
      renderCell: (params) =>
        params.value ? <Chip size="small" color="success" label={t('documentTemplates.default')} /> : null,
    },
  ];

  const fields = [
    { name: 'name', label: t('documentTemplates.name'), type: 'text' as const, required: true },
    { name: 'is_default', label: t('documentTemplates.isDefault'), type: 'boolean' as const },
    { name: 'description', label: t('documentTemplates.description'), type: 'text' as const, width: 'full' as const },
    { name: 'header_text', label: t('documentTemplates.headerText'), type: 'text' as const, width: 'half' as const },
    { name: 'footer_text', label: t('documentTemplates.footerText'), type: 'text' as const, width: 'half' as const },
    { name: 'logo_url', label: t('documentTemplates.logo'), type: 'image' as const, bucket: 'documents', width: 'full' as const },
    { name: 'primary_color', label: t('documentTemplates.primaryColor'), type: 'text' as const },
    { name: 'font_family', label: t('documentTemplates.fontFamily'), type: 'text' as const },
    {
      name: 'orientation',
      label: t('documentTemplates.orientation'),
      type: 'select' as const,
      options: [
        { value: 'portrait', label: isRTL ? 'عمودي' : 'Portrait' },
        { value: 'landscape', label: isRTL ? 'أفقي' : 'Landscape' },
      ],
    },
    { name: 'columns', label: t('documentTemplates.columns'), type: 'text' as const, width: 'half' as const },
    { name: 'max_rows', label: t('documentTemplates.maxRows'), type: 'number' as const, width: 'half' as const },
    { name: 'body_html', label: t('documentTemplates.bodyHtml'), type: 'textarea' as const, width: 'full' as const },
  ];

  return (
    <GenericTablePage
      tableName="document_templates"
      title={t('documentTemplates.title')}
      columns={columns}
      fields={fields}
    />
  );
};

export default DocumentTemplatesPage;
